import React from 'react';
import PropTypes from 'prop-types';
import AppSafeLink from 'components/AppSafeLink/AppSafeLink';

// True for absolute http(s) links whose host isn't mprnews.org or a subdomain of it.
// Relative, mailto: and tel: links return false, so they don't open in a new tab.
const isExternalLink = (href) =>
  /^https?:\/\//i.test(href) &&
  !/^https?:\/\/([a-z0-9-]+\.)*mprnews\.org(\/|$|\?|#)/i.test(href);

const LinkOverride = (props) => {
  const externalProps = isExternalLink(props.href)
    ? { target: '_blank', rel: 'noopener noreferrer' }
    : {};

  return (
    <AppSafeLink
      title={props.title}
      className={`apm-link ${props.className}`}
      href={props.href}
      {...externalProps}
    >
      {props.inner}
    </AppSafeLink>
  );
};

LinkOverride.propTypes = {
  inner: PropTypes.object,
  href: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default LinkOverride;
